const Divider = {
    "options": {
        "customization": {
            "backgroundColor": {
                "type": "HexColor"
            },
            "height": {
                "type": "RangePx",
                "data": {
                    "max": 300,
                    "min": 0,
                    "step": 1
                }
            }
        }
    },
    "variants": [
        {
            "id": "Divider",
            "name": "Divider",
            "type": "Divider",
            "data": {},
            "customization": {
                "height": "10px",
                "backgroundColor": "#ffffff"
            },
            "variantData": {
                "isEditable": false
            },
            "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/Empty%402x.png",
            "minMobileAppVersion": 1,
            "isComingSoon": false
        }
    ]
}
 export default Divider